import template from './ko-field-input-email.html';

class EmailInputComponentVM
{
	constructor(params)
	{
		this.params = params;

		this.name = ko.observable(params.name);
		this.label = ko.observable(params.label);
		this.$input = params.$input;
		this.readonly = ko.observable(params.readonly);
	}
}


export default {
	name: 'ko-field-input-email',
	viewModel: EmailInputComponentVM,
	module_type: 'ko',
	template: template
}
